import {
    apiConstants,
    config,
    mockResolveApiCall,
    requestOptions,
    requestTypes,
    sendRequest,
} from "../../Utilities/Api";
import {getLoggedInUser} from "../../Utilities/LocalStorage/storageUtilities";

class ServerUserApi {
    static attemptLogin(signInModel: Record<string, unknown>) {
        return sendRequest(
            requestOptions(config.URL + "accounts/login/",
                requestTypes.POST,
                JSON.stringify(signInModel),
            ),
        );
    }

    static attemptLogout() {
        return sendRequest(
            requestOptions(config.URL + "accounts/logout/",
                requestTypes.POST,
                null,
                apiConstants.successMessage.user.LOGOUT
            ),
        );
    }

    static attemptRegister(registerModel: Record<string, unknown>) {
        let attemptRegisterOptions = requestOptions(config.URL + "accounts/register",
            requestTypes.POST,
            JSON.stringify(registerModel),
            apiConstants.successMessage.user.REGISTER
        );

        return sendRequest(attemptRegisterOptions);
    }

    static getUser()
    {
        const userId = getLoggedInUser();
        return sendRequest(
            requestOptions(config.URL + `users/${userId}`,
                requestTypes.GET,
            ),
        );
    }

    static updateUserPreference(userId: string, key: string, value: string) {
        return sendRequest(
            requestOptions(config.URL + "users/preference",
                requestTypes.POST,
                JSON.stringify({ userId, key, value }),
            ),
        );
    }

    static getOrganizations() {
        return sendRequest(
            requestOptions(`${config.URL}users/organizations/`,
                requestTypes.GET,
            )
        );
    }
}

class MockUserApi {
    static attemptLogin() {
        return mockResolveApiCall({}, "");
    }

    static attemptLogout() {
        return mockResolveApiCall({}, "");
    }

    static attemptRegister() {
        return mockResolveApiCall({}, "");
    }

    static getUser() {
        return mockResolveApiCall({}, "");
    }

    static updateUserPreference() {
        return mockResolveApiCall({}, "");
    }

    static getOrganizations() {
        return mockResolveApiCall({}, "");
    }
}

export const userApi = config.environment.MODE === config.modes.SERVER ? ServerUserApi : MockUserApi;
